import { defineStore } from 'pinia'

export const useNavItemStore = defineStore('navItem', {
  state: () => ({
    navItems: [
      {
        root: '/',
        to: '/',
        icon: 'las la-home',
        labelKey: 'home',
        separator: false,
      },
      {
        root: '/my-tasks',
        to: '/my-tasks',
        icon: 'las la-tasks',
        labelKey: 'myTasks',
        separator: false,
      },
      {
        root: '/stores',
        to: '/stores',
        icon: 'las la-store',
        labelKey: 'stores',
        separator: false,
      },
      {
        root: '/time-tracking',
        to: '/time-tracking',
        icon: 'las la-hourglass-half',
        labelKey: 'timeTracking',
        separator: false,
      },
      {
        root: '/inventory',
        to: '/inventory',
        icon: 'las la-boxes',
        labelKey: 'inventory',
        separator: false,
      },
      {
        root: '/preferences',
        to: '/preferences',
        icon: 'las la-cog',
        labelKey: 'preferences',
        separator: false,
      },
      {
        root: '/messaging',
        to: '/messaging',
        icon: 'las la-sms',
        labelKey: 'messaging',
        separator: false,
      },
      {
        root: '/timeline',
        to: '/timeline',
        icon: 'las la-clock',
        labelKey: 'timeline',
        separator: false,
      },
    ],
    bottomTabNavItems: [
      {
        root: '/',
        to: '/',
        icon: 'home',
        labelKey: 'home',
      },
      {
        root: '/stores',
        to: '/stores',
        icon: 'store',
        labelKey: 'stores',
      },
      {
        root: '/tasks',
        to: '/tasks',
        icon: 'task',
        labelKey: 'tasks',
      },
      {
        root: '/inventory',
        to: '/inventory',
        icon: 'inventory',
        labelKey: 'inventory',
      },
    ],
  }),
})
